import { render, staticRenderFns } from "./layout-sider.vue?vue&type=template&id=6d82a18f&scoped=true"
import script from "./layout-sider.vue?vue&type=script&lang=js"
export * from "./layout-sider.vue?vue&type=script&lang=js"
import style0 from "./layout-sider.vue?vue&type=style&index=0&id=6d82a18f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d82a18f",
  null
  
)

export default component.exports